import { render, staticRenderFns } from "./WapFooter.vue?vue&type=template&id=d3d5a1ee&"
import script from "./WapFooter.vue?vue&type=script&lang=js&"
export * from "./WapFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports